import { render, staticRenderFns } from "./sended.vue?vue&type=template&id=4484b1be&"
import script from "./sended.vue?vue&type=script&lang=js&"
export * from "./sended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports